/**
 * Episode/channel pairs whose VOD access was revoked live this session via the
 * `App\Events\PublicVodDisabledEvent` Pusher event (the backend recalculates
 * `can_watch_vod` on player-events and pushes the change).
 *
 * Plain module state — not Redux, not reactive — on purpose: a revocation that
 * arrives while the user is watching must NOT interrupt the running player. It
 * only overrides `can_watch_vod` the next time the player page for that
 * episode/channel is opened. Cleared on logout so it never leaks across users
 * sharing a tab.
 */
var revokedKeys = new Set();
var buildKey = function (episodeId, channelId) { return "".concat(episodeId, ":").concat(channelId); };
/** Apply a `PublicVodDisabledEvent` payload: `canWatchVod` falsy revokes, truthy restores. */
export var setVodAccessRevoked = function (episodeId, channelId, canWatchVod) {
    var key = buildKey(episodeId, channelId);
    if (canWatchVod)
        revokedKeys.delete(key);
    else
        revokedKeys.add(key);
};
/** True when this episode/channel had its VOD access revoked live this session. */
export var isVodAccessRevoked = function (episodeId, channelId) {
    return episodeId != null && channelId != null && revokedKeys.has(buildKey(episodeId, channelId));
};
/** Drop every live revocation — call on logout. */
export var clearVodAccessRevoked = function () {
    revokedKeys.clear();
};
